module.exports = __webpack_public_path__ + "img/2.6503b9a2.png";